const PIXEL_ID = '3026223277561270';

type FbqFn = (...args: unknown[]) => void;
const getFbq = (): FbqFn | undefined => (window as Window & { fbq?: FbqFn }).fbq;

async function sha256(value: string): Promise<string> {
  const encoded = new TextEncoder().encode(value.trim().toLowerCase());
  const buffer = await crypto.subtle.digest('SHA-256', encoded);
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

export async function initPixelWithUser(email: string, name: string) {
  const fbq = getFbq();
  if (!fbq) return;
  const parts = name.trim().split(/\s+/);
  const [em, fn, ln] = await Promise.all([
    sha256(email),
    sha256(parts[0] ?? ''),
    sha256((parts.slice(1).join(' ') || parts[0]) ?? ''),
  ]);
  fbq('init', PIXEL_ID, { em, fn, ln });
}

export function trackPageView() {
  getFbq()?.('track', 'PageView');
}

export function trackEvent(event: string, params?: Record<string, unknown>, eventId?: string) {
  const fbq = getFbq();
  if (eventId) {
    fbq?.('track', event, params, { eventID: eventId });
  } else {
    fbq?.('track', event, params);
  }
}
